const INIT_SOLUTIONS = [
    {
        name: 'Ecommerce',
        href: '',
    },
    {
        name: 'SaaS',
        href: '',
    },
    {
        name: 'Marketplaces',
        href: '',
    },
    {
        name: 'Embedded Finance',
        href: '',
    },
    {
        name: 'Platforms',
        href: '',
    },
    {
        name: 'Creator Economy',
        href: '',
    },
    {
        name: 'Crypto',
        href: '',
    },
    {
        name: 'Global Businesses',
        href: '',
    },
];

export default INIT_SOLUTIONS;
